import classNames from 'classnames'
import { ComponentProps, ReactElement } from 'react'

interface Props extends ComponentProps<'svg'> {
  color?: string
}
export function IconCorrections({ color = 'currentColor', className, ...props }: Props): ReactElement {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className, 'w-[1em] h-[1em]')}
      {...props}
    >
      <path
        d="M11.1037 5.08496C11.5537 5.08496 11.9474 5.34371 12.1274 5.74871L12.8587 7.39121C12.9262 7.53746 12.9599 7.69496 12.9599 7.85246V11.835C12.9599 12.4537 12.4537 12.96 11.8349 12.96H6.20992C5.59117 12.96 5.08492 12.4537 5.08492 11.835V7.85246C5.08492 7.69496 5.11867 7.53746 5.18617 7.39121L5.91742 5.74871C6.09742 5.34371 6.50242 5.08496 6.94117 5.08496H11.1037ZM11.0362 5.92871H9.56242V7.17746H11.7562L11.2612 6.07496C11.2274 5.98496 11.1262 5.92871 11.0362 5.92871ZM11.8912 8.26871H6.15367V11.6887C6.15367 11.835 6.26617 11.9475 6.41242 11.9475H11.6212C11.7674 11.9475 11.8799 11.8237 11.8799 11.6887V8.26871H11.8912ZM6.31117 7.17746H8.50492V5.92871H7.03117C6.92992 5.92871 6.83992 5.98496 6.80617 6.07496L6.31117 7.17746Z"
        fill={color}
      />
      <path
        d="M13.2074 3.20621L10.7999 3.88121C10.4062 4.00496 10.0349 3.58871 10.2149 3.23996L10.5412 2.60996C10.0349 2.47496 9.50617 2.40746 8.95492 2.40746C5.32117 2.40746 2.36242 5.36621 2.36242 8.99996C2.36242 10.8112 3.09367 12.465 4.28617 13.6462L3.23992 15.075C1.61992 13.5675 0.607422 11.3962 0.607422 8.99996C0.607422 4.38746 4.34242 0.652459 8.95492 0.652459C9.78742 0.652459 10.5749 0.776209 11.3399 1.00121L11.6662 0.314959C11.8349 -0.033791 12.3862 0.022459 12.5324 0.404959L13.4774 2.65496C13.5674 2.89121 13.4437 3.13871 13.2074 3.20621Z"
        fill={color}
      />
      <path
        d="M4.79242 14.7937L7.19992 14.1187C7.59367 13.995 7.96492 14.4112 7.78492 14.76L7.45867 15.39C7.96492 15.525 8.49367 15.5925 9.04492 15.5925C12.6787 15.5925 15.6374 12.6337 15.6374 8.99996C15.6374 7.18871 14.9062 5.53496 13.7137 4.35371L14.7599 2.92496C16.3799 4.43246 17.3924 6.60371 17.3924 8.99996C17.3924 13.6125 13.6574 17.3475 9.04492 17.3475C8.21242 17.3475 7.42492 17.2237 6.65992 16.9987L6.33367 17.685C6.16492 18.0337 5.61367 17.9775 5.46742 17.595L4.52242 15.345C4.43242 15.1087 4.55617 14.8612 4.79242 14.7937Z"
        fill={color}
      />
    </svg>
  )
}
